import { constVoid, DOM, IOO, pipe, RR, s, v } from '@packages/prelude'
import { Swiper, Pagination, Navigation, SwiperOptions, Thumbs } from 'swiper'

import '../css/main.scss'
import 'bootstrap'

pipe(
  IOO.of({ document }),
  IOO.bind('main', ({ document }) => pipe(document, DOM.querySelector('main'))),
  IOO.bind('scrollBtn', ({ document }) => pipe(document, DOM.querySelector('.header-scroll-down'))),
  IOO.chainFirstIOK(({ main, scrollBtn }) =>
    DOM.addEventListener('click')(() => () => main.scrollIntoView())(scrollBtn)
  )
)()

const makeSwiper = (selector: string, options: SwiperOptions) =>
  pipe(
    IOO.of({ document }),
    IOO.chain(({ document }) => pipe(document, DOM.querySelector(`#${selector}`)) as IOO.IOOption<HTMLElement>),
    IOO.fold(
      () => constVoid,
      element => IOO.of(new Swiper(element, options))
    )
  )()

const Swipers: Record<string, SwiperOptions> = {
  serviceRange: {
    modules: [Thumbs, Navigation],
    slidesPerView: 1,
    speed: 750,
    spaceBetween: 24,
    thumbs: {
      swiper: new Swiper('#serviceRangeThumbs', {
        slidesPerView: 6,
        slideToClickedSlide: true
      })
    },
    navigation: {
      prevEl: '.btn-service-prev',
      nextEl: '.btn-service-next'
    }
  },
  gallery: {
    modules: [Navigation, Pagination],
    speed: 750,
    loop: true,
    navigation: {
      prevEl: '.btn-gallery-prev',
      nextEl: '.btn-gallery-next'
    },
    pagination: {
      el: '.gallery-pagination'
    }
  },
  news: {
    speed: 750,
    modules: [Navigation],
    loop: false,
    spaceBetween: 24,
    slidesPerView: 1,
    navigation: {
      prevEl: '.btn-news-prev',
      nextEl: '.btn-news-next'
    },
    breakpoints: {
      768: {
        slidesPerView: 2
      }
    }
  }
}

pipe(
  Swipers,
  RR.foldMapWithIndex(s.Ord)(v.Monoid)((selector, options) => makeSwiper(selector, options))
)
